import script from "./register.vue?vue&type=script&lang=ts&setup=true"
export * from "./register.vue?vue&type=script&lang=ts&setup=true"

import "./register.vue?vue&type=style&index=0&id=44da7f9e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44da7f9e"]])

export default __exports__